const baseLoginModule = require('base/login/login');

const formValidation = require('../components/formValidation');
var clientSideValidation = require('../components/clientSideValidation');
var createErrorNotification = require('base/components/errorNotification');
var gtm = require('googletagmanager/tagManager');

const customLoginModule = {...baseLoginModule};

customLoginModule.login = function () {
    $('form.login').submit(function (e) {
        var form = $(this);
        e.preventDefault();

        var isValid = clientSideValidation.checkMandatoryField(form);
        if (!isValid) {
            return false;
        }

        var url = form.attr('action');
        form.spinner().start();
        form.trigger('login:submit', e);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                form.spinner().stop();
                if (!data.success && data.isLegacyCustomer) {
                    formValidation(form, data);
                    $('form.login').trigger('login:error', data);
                    $('#legacyResetPasswordModal').modal('show');
                } else if (!data.success) {
                    formValidation(form, data);
                    form.find('.form-control.is-invalid').first().focus();
                    $('form.login').trigger('login:error', data);
                } else {
                    $('form.login').trigger('login:success', data);
                    sessionStorage.setItem('loggedInSuccessful', 'true');
                    window.location.href = data.redirectUrl;
                }
            },
            error: function (data) {
                if (data.responseJSON.redirectUrl) {
                    window.location.href = data.responseJSON.redirectUrl;
                } else {
                    $('form.login').trigger('login:error', data);
                    form.spinner().stop();
                }
            }
        });
        return false;
    });
};

customLoginModule.resetPassword = function () {
    $('body').on('submit', '.reset-password-form', function (e) {
        var form = $(this);
        e.preventDefault();
        var url = form.attr('action');
        form.spinner().start();
        $('.reset-password-form').trigger('login:register', e);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                form.spinner().stop();
                if (!data.success) {
                    formValidation(form, data);
                } else {
                    var $resetPasswordModal = $('#requestPasswordResetModal');
                    var originalContent = $resetPasswordModal.html();

                    $('#requestPasswordResetModal').on('hide.bs.modal', function () {
                        $(this).html(originalContent);
                    });
                    $('.request-password-title').text(data.receivedMsgHeading);
                    $('.modal-close-btn').on('click', function () {
                        window.location.href = data.returnUrl;
                    });
                    $('.login-cancel-button').remove();
                    $('.request-password-body').empty()
                        .append('<p class="small">' + data.receivedMsgBody + '</p>');
                    if (!data.mobile) {
                        $('#submitEmailButton, #submitEmailButtonCaptcha').text(data.buttonText)
                            .attr('data-dismiss', 'modal')
                            .on('click', function () {
                                window.location.href = data.returnUrl; 
                            });
                    } else {
                        $('.send-email-btn').empty()
                            .html('<a href="'
                                + data.returnUrl
                                + '" class="btn btn-primary btn-block btn--rounded">'
                                + data.buttonText + '</a>');
                    }
                }
            },
            error: function () {
                form.spinner().stop();
            }
        });
        return false;
    });
};

customLoginModule.register = function () {
    $('form.registration').submit(function (e) {
        var form = $(this);
        e.preventDefault();

        var isValid = clientSideValidation.checkMandatoryField(form);
        if (!isValid) {
            return false;
        }
        
        var url = form.attr('action');
        form.spinner().start();
        $('form.registration').trigger('login:register', e);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                form.spinner().stop();
                if (!data.success) {
                    $('form.registration').trigger('login:register:error', data);
                    formValidation(form, data);
                    form.find('.form-control.is-invalid').first().focus();
                } else {
                    $('form.registration').trigger('login:register:success', data);
                    gtm.accountRegister();
                    window.location.href = data.redirectUrl;
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
                }
    
                form.spinner().stop();
            }
        });
        return false;
    });
};

customLoginModule.checkOrder = function () {
    $('form.trackorder').submit(function (e) {
        var form = $(this);
        e.preventDefault();

        var isValid = clientSideValidation.checkMandatoryField(form);
        if (!isValid) {
            return false;
        }

        var url = form.attr('action');
        form.spinner().start();
        $('form.trackorder').trigger('trackorder:submit', e);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                form.spinner().stop();
                if (!data.success) {
                    formValidation(form, data);
                    form.find('.form-control.is-invalid').first().focus();
                    $('form.trackorder').trigger('trackorder:error', data);
                    if (data.errorMsg) {
                        var errorHtml = '<div class="form-group mb-3">'
                        + '<div class="alert-danger check-order-error mk-rounded-3 p-3 small" role="alert">'
                        + '<div class="lookup-msg mb-1 mk-fw-xbold">'+ ('errorMsgHead' in data ? data.errorMsgHead : '') +'</div>'
                        + '<span>'+ data.errorMsg +'</span>'
                        + '</div>'
                        + '</div>'
                        $('.checkorder-error').empty().append(errorHtml);
                    }
                    form.spinner().stop();
                } else {
                    $('form.trackorder').trigger('trackorder:success', data);
                    window.location.href = data.redirectUrl;
                }
            },
            error: function (data) {
                if (data.errorMsg) {
                    var errorHtml = '<div class="form-group">'
                        + '<div class="alert alert-danger " role="alert">'
                        + '<strong>'+ data.errorMsg +'</strong>'
                        + '</div>'
                        + '</div>'
                    $('.checkorder-error').empty().append(errorHtml);
                }
                $('form.trackorder').trigger('trackorder:error', data);
                form.spinner().stop();
            }
        });
        return false;
    });
};

module.exports = customLoginModule;
